import dayjs from "dayjs";
var PATH_PREMIER_COLLECTION_HOME = "/premium-stays/";
export var PATH_PREMIER_COLLECTION_SHOP_DETAILS = PATH_PREMIER_COLLECTION_HOME + "shop-details/";
export var DatelessSearchSource;
(function (DatelessSearchSource) {
    DatelessSearchSource["MyTrips"] = "MyTrips";
    DatelessSearchSource["Email"] = "Email";
    DatelessSearchSource["SearchPage"] = "SearchPage";
    DatelessSearchSource["OffersSearchPage"] = "OffersSearchPage";
    DatelessSearchSource["Shop"] = "Shop";
    DatelessSearchSource["Vibes"] = "Vibes";
    DatelessSearchSource["Unknown"] = "Unknown";
    DatelessSearchSource["UnavailableInList"] = "unavailable_in_list";
})(DatelessSearchSource || (DatelessSearchSource = {}));
export var transformToShopDetailsStringifiedQuery = function (_a) {
    var lodgingId = _a.lodgingId, _b = _a.unavailable, unavailable = _b === void 0 ? false : _b, source = _a.source, vibe = _a.vibe, fromDate = _a.fromDate, untilDate = _a.untilDate, isTravelApp = _a.isTravelApp;
    var query = "?lodgingId=".concat(lodgingId, "&source=").concat(source);
    if (unavailable) {
        query += "&unavailable=".concat(unavailable);
    }
    if (vibe) {
        query += "&vibe=".concat(encodeURIComponent(vibe));
    }
    if (fromDate) {
        query += "&fromDate=".concat(dayjs(fromDate).format("YYYY-MM-DD"));
    }
    if (untilDate) {
        query += "&untilDate=".concat(dayjs(untilDate).format("YYYY-MM-DD"));
    }
    if (isTravelApp) {
        query += "&isTravelApp=".concat(isTravelApp);
    }
    return query;
};
//# sourceMappingURL=navigation.js.map